import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { CampaignContextProvider } from "./contexts/CampaignContext"
import { CampaignDesktopRouter } from "./routers/CampaignDesktopRouter"
import { CampaignMobileRouter } from "./routers/CampaignMobileRouter"

export function L2rAppCampaign() {

    const isMobile = useIsMobileDevice()

    return (
        <CampaignContextProvider>
            {isMobile ? <CampaignMobileRouter /> : <CampaignDesktopRouter />}
        </CampaignContextProvider>
    )
}
